import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { BottomNav } from '../components/BottomNav';
import { ProductCard } from '../components/ProductCard';
import { products } from '../data/mockData';
export function Products() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'active' | 'pending' | 'rejected'>('active');
  const filteredProducts = products.filter(p => {
    if (activeTab === 'active') return p.status === 'approved';
    if (activeTab === 'pending') return p.status === 'pending';
    return p.status === 'rejected';
  });
  const tabs = [{
    id: 'active' as const,
    label: 'Active',
    count: products.filter(p => p.status === 'approved').length
  }, {
    id: 'pending' as const,
    label: 'Pending',
    count: products.filter(p => p.status === 'pending').length
  }, {
    id: 'rejected' as const,
    label: 'Rejected',
    count: products.filter(p => p.status === 'rejected').length
  }];
  return <div className="min-h-screen pb-24" data-id="element-336">
      <div className="max-w-md mx-auto" data-id="element-337">
        {/* Header */}
        <div className="flex justify-between items-center p-5 pt-8" data-id="element-338">
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-339">
            Products
          </h1>
          <motion.button whileTap={{
          scale: 0.95
        }} onClick={() => navigate('/products/upload')} className="bg-[#00D68F] text-[#0A0E1A] rounded-full px-4 py-2 flex items-center gap-2 font-bold shadow-[0_0_20px_rgba(0,214,143,0.2)]" data-id="element-340">
            <Plus className="w-5 h-5" data-id="element-341" />
            Add New
          </motion.button>
        </div>

        {/* Pill Tabs */}
        <div className="px-5 mb-6" data-id="element-342">
          <div className="glass-card p-1 flex" data-id="element-343">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 relative z-10 ${activeTab === tab.id ? 'text-[#0A0E1A]' : 'text-[#64748B] hover:text-white'}`} data-id="element-344">
                {activeTab === tab.id && <motion.div layoutId="productTab" className="absolute inset-0 bg-[#00D68F] rounded-xl -z-10 shadow-[0_0_15px_rgba(0,214,143,0.2)]" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-345" />}
                {tab.label}{' '}
                <span className="opacity-60 ml-1" data-id="element-346">({tab.count})</span>
              </button>)}
          </div>
        </div>

        {/* Products List */}
        <div className="px-5" data-id="element-347">
          <AnimatePresence mode="wait" data-id="element-348">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2
          }} className="space-y-3" data-id="element-349">
              {filteredProducts.length > 0 ? filteredProducts.map((product, index) => <motion.div key={product.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-350">
                    <ProductCard product={product} data-id="element-351" />
                  </motion.div>) : <div className="text-center py-16 glass-card" data-id="element-352">
                  <p className="text-[#64748B] font-medium" data-id="element-353">
                    No {activeTab} products found
                  </p>
                </div>}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <BottomNav data-id="element-354" />
    </div>;
}